// Keeps a free-wedge operator off the portfolio dashboard.
//
// The admin dashboard is built out of occupancy, revenue, invoices and leads.
// A free visitor or free meeting-room org has none of those, and the wedge
// boundary (accounts/wedge.py) closes the endpoints behind them, so the page
// would render as a wall of empty widgets and failed calls. Every route that
// can drop someone there gets wrapped in this, so a bookmark, a breadcrumb or
// a stale link lands them on their own module instead.
//
// Full-platform orgs pass straight through.

import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
import { wedgeHome } from '../layouts/dashboard/navbar/WedgeNavConfig';

export default function WedgeHomeRedirect({ children }) {
  const { user } = useAuth();
  const home = wedgeHome(user?.planKind);

  if (home) return <Navigate to={home} replace />;

  return children;
}

WedgeHomeRedirect.propTypes = {
  children: PropTypes.node,
};
